var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.233398,
    width: 64,
    height: 61,
    rx: 12,
    fill: "#6395EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6835 21.914C10.9073 26.5042 10.7559 34.1216 15.3461 38.8978C19.7833 43.5149 27.0238 43.7846 31.8226 39.6633C36.4539 43.972 43.6995 43.99 48.3165 39.5528C53.0927 34.9626 53.2441 27.3452 48.6539 22.569C44.2167 17.952 36.9762 17.6822 32.1774 21.8035C27.5461 17.4948 20.3005 17.4768 15.6835 21.914ZM32.1364 23.8647C32.4101 24.2142 32.7161 24.5326 32.9587 24.912L29.9014 27.8502C30.3056 26.421 31.0817 25.0626 32.1364 23.8647ZM33.6193 26.2367C33.8295 26.7094 33.9763 27.1808 34.153 27.6833L29.536 32.1205C29.4849 31.4948 29.4364 30.8691 29.4488 30.2447L33.6193 26.2367ZM34.4964 29.3152C34.5772 29.972 34.5959 30.5666 34.5524 31.2209L30.3806 35.2302C30.1703 34.7575 29.9937 34.255 29.8468 33.7836L34.4964 29.3152ZM34.0973 33.6178C33.6621 35.0769 32.917 36.4054 31.8636 37.6021C31.5899 37.2526 31.2839 36.9341 31.0413 36.5548L34.0973 33.6178ZM47.635 23.548C51.6741 27.7508 51.5401 34.4952 47.3373 38.5342C43.2938 42.4203 36.9212 42.4196 32.8422 38.6208C34.6631 36.6268 35.6794 34.1786 35.9153 31.6861C35.9477 31.5928 35.9501 31.5306 35.9203 31.4373C36.1366 28.4109 35.1971 25.3322 33.1237 22.8561C37.3812 19.2525 43.749 19.5044 47.635 23.548ZM31.1573 22.8461C29.3363 24.8402 28.3201 27.2883 28.0828 29.8444C28.0504 29.9377 28.048 29.9999 28.0778 30.0932C27.8615 33.1196 28.801 36.1983 30.8448 38.6435C26.6195 42.2137 20.2506 42.025 16.3645 37.9814C12.3255 33.7786 12.4595 27.0342 16.6622 22.9951C20.7059 19.0468 27.0785 19.0475 31.1573 22.8461Z",
    fill: "#EFF7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksMatch);
export default __webpack_public_path__ + "static/media/HowItWorksMatch.be0a2be16bf8359a285a274a63cf26e6.svg";
export { ForwardRef as ReactComponent };